//-----------------------imports-----------------------
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { locationdata, Taxdata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import SearchAppBar from "../../components/common/search";
import { useSelector } from "react-redux";
import { TAX_API_01, MAPLOCATION_API_01 } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { TextField, Autocomplete } from "@mui/material";
import AddLinkIcon from "@mui/icons-material/AddLink";
function ViewTaxpage() {
  //----------------------hooks------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, TAXCODE, USERREFCODE, RESTCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(TAX_API_01, "get", {
          COMPCODE,
          LOCCODE: selectedLOC.LOCCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setFilteredRows(result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedLOC]);

  useEffect(() => {
    if (data) {
      const filtered = data.filter(
        (item) =>
          item.TAXTYPE.toLowerCase().includes(searchText.toLowerCase()) ||
          item.TAXRATE.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredRows(filtered);
    }
  }, [searchText, data]);

  //----------------functions--------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const gotToPage = () => {
    navigate("/Createtaxcharge");
  };

  const gotToPage1 = () => {
    navigate("/MapTaxandCharges");
  };
  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.TAXCODE === id);
      if (selectedItem) {
        navigate(`/Createtaxcharge`, {
          state: {
            selectedItem,
            actionText,
            LOCCODE: selectedLOC.LOCCODE,
          },
        });
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result); // Populate orderData with the updated array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
    }
  }, [dataloc]);

  const handleSelectionloc = (newvalue) => {
    setSelectedLOC(newvalue);
    console.log("Selected value:", newvalue);
    // Pass the selected value to any required function here
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (TAXCODE) => handleItemClick(TAXCODE, "Edit"),
    },
    {
      text: "Map Tax",
      icon: <AddLinkIcon />,
      onClick: (TAXCODE) => gotToPage1(TAXCODE), // Corrected function syntax
    },
  ];

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Location</Link>
                <Link underline="none">View Locations</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      sx={{ width: 300 }}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Update the state correctly
                  }}
                  value={
                    Array.isArray(dataloc) && dataloc.length > 0
                      ? selectedLOC
                      : null
                  }
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />

                <Button
                  onClick={() => gotToPage()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Taxdata.columns}
          rows={filteredRows.map((item) => ({ ...item, id: item.TAXCODE }))}
          menuItems={menuItems}
          tabletitle={Taxdata.name}
          gridid="TAXCODE"
        />
      )}
    </div>
  );
}

export default ViewTaxpage;
